module.exports = __webpack_public_path__ + "img/cnmc-logo.d15f7a25.png";